import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiServiceBase, API_NAMES } from '../api';

export interface MenuItem {
  label: string;
  route: string;
  icon: string;
  scope: string;
  visible: boolean;
  children: MenuItem[];
  isFavorite: boolean;
  status: string;
  isAuthorization?: boolean;
}

@Injectable({ providedIn: 'root' })
export class MenuService extends ApiServiceBase {
  private sidebarMenuCache: { [key: string]: MenuItem[] } = {};
  private adminMenuCache: { [key: string]: MenuItem[] } = {};

  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.administration);
  }

  getSidebarMenu(baseStr: string = 'stock', forceRefresh = false) {
    const cacheKey = `sidebar_menu_${baseStr}`;
    if (!forceRefresh && this.sidebarMenuCache[baseStr]) {
      return of(this.sidebarMenuCache[baseStr]);
    }
    const cached = localStorage.getItem(cacheKey);
    if (cached && !forceRefresh) {
      try {
        const parsed = JSON.parse(cached);
        this.sidebarMenuCache[baseStr] = parsed;
        return of(parsed);
      } catch (e) {
        localStorage.removeItem(cacheKey);
      }
    }
    return this.http.get<MenuItem[]>(this.url(`/menu/sidebar?baseStr=${baseStr}`)).pipe(
      tap(menu => {
        this.sidebarMenuCache[baseStr] = menu;
        localStorage.setItem(cacheKey, JSON.stringify(menu));
      })
    );
  }

  getAdminMenu(baseStr: string = 'stock', forceRefresh = false) {
    const cacheKey = `admin_menu_${baseStr}`;
    if (!forceRefresh && this.adminMenuCache[baseStr]) {
      return of(this.adminMenuCache[baseStr]);
    }
    const cached = localStorage.getItem(cacheKey);
    if (cached && !forceRefresh) {
      try {
        const parsed = JSON.parse(cached);
        this.adminMenuCache[baseStr] = parsed;
        return of(parsed);
      } catch (e) {
        localStorage.removeItem(cacheKey);
      }
    }
    return this.http.get<MenuItem[]>(this.url(`/menu/admin?baseStr=${baseStr}`)).pipe(
      tap(menu => {
        this.adminMenuCache[baseStr] = menu;
        localStorage.setItem(cacheKey, JSON.stringify(menu));
      })
    );
  }

  clearMenuCache() {
    this.sidebarMenuCache = {};
    this.adminMenuCache = {};
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const key = localStorage.key(i);
      if (key && (key.startsWith('sidebar_menu_') || key.startsWith('admin_menu_'))) {
        localStorage.removeItem(key);
      }
    }
  }
}

